import { ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import { ReactElement } from "react"

import { useScreenSize } from "../../../../hooks/useScreenSize"
import AppChip from "../../../dataDisplay/chips/appChip"
import LctAvatar from "../../../pills/lct/lctAvatar"

interface IListItemProps {
    lcts?: string[]
    title: string
    subtitle: string
    subtitleAdditional: string
    chipText: string
    chipOverride?: ReactElement
    onClick: () => void
}

/**
 * Renders a list item for mobile view in the application table.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string[]} props.lcts - The list of LCTs.
 * @param {string} props.title - The title of the list item.
 * @param {string} props.subtitle - The subtitle of the list item.
 * @param {string} props.subtitleAdditional - The additional subtitle of the list item.
 * @param {string} props.chipText - The text for the chip.
 * @param {Function} props.onClick - The click event handler for the list item.
 */
const MobileListItems = ({
    lcts,
    title,
    subtitle,
    subtitleAdditional,
    chipText,
    onClick,
    chipOverride,
}: IListItemProps): ReactElement => {
    const { isTablet } = useScreenSize()
    return (
        <ListItem divider onClick={() => onClick()} sx={{ paddingX: 0 }}>
            {lcts !== undefined && (
                <ListItemAvatar>
                    <LctAvatar lcts={lcts} />
                </ListItemAvatar>
            )}

            <ListItemText
                sx={{ whiteSpace: "nowrap" }}
                primary={title}
                secondary={`${subtitle} \u2022 ${subtitleAdditional}`}
                secondaryTypographyProps={{ noWrap: true }}
                primaryTypographyProps={{ noWrap: true }}
            />

            {isTablet &&
                (chipOverride || (
                    <AppChip
                        label={chipText}
                        color="primary"
                        variant="outlined"
                    />
                ))}
        </ListItem>
    )
}

MobileListItems.defaultProps = {
    lcts: undefined,
    chipOverride: undefined,
}

export default MobileListItems
